var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRubbishBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rubbish-bin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 14,
    viewBox: "0 0 10.5 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7149",
    "data-name": "Group 7149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19286",
    "data-name": "Path 19286",
    d: "M74.516,109.384a.707.707,0,0,0,.708.675h6.619a.707.707,0,0,0,.708-.675l.473-9.916H74.043Zm5.515-7.453a.287.287,0,0,1,.288-.286h.461a.287.287,0,0,1,.288.286V107.6a.287.287,0,0,1-.288.286h-.461a.287.287,0,0,1-.288-.286Zm-2.015,0a.287.287,0,0,1,.288-.286h.461a.287.287,0,0,1,.288.286V107.6a.287.287,0,0,1-.288.286H78.3a.287.287,0,0,1-.288-.286v-5.665Zm-2.016,0a.287.287,0,0,1,.288-.286h.461a.287.287,0,0,1,.288.286V107.6a.287.287,0,0,1-.288.286h-.461A.287.287,0,0,1,76,107.6Z",
    transform: "translate(-73.283 -96.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19287",
    "data-name": "Path 19287",
    d: "M62.071.721H59.018V.148A.148.148,0,0,0,58.869,0H55.663a.148.148,0,0,0-.148.148V.721H52.461a.444.444,0,0,0-.445.442V2.552h10.5V1.163A.444.444,0,0,0,62.071.721Z",
    transform: "translate(-52.016)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubbishBin);
export default __webpack_public_path__ + "static/media/rubbish-bin.3fc4d179edfa15226914e6a3f50cd602.svg";
export { ForwardRef as ReactComponent };